import React from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export const RejectOrderDialog = ({ rejectFor, onClose, rejectReason, setRejectReason, busy, onSubmit }) => (
  <Dialog open={!!rejectFor} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="order-reject-dialog">
      <DialogHeader><DialogTitle>Reject Order {rejectFor?.order_no}</DialogTitle></DialogHeader>
      <div className="space-y-2">
        <Label>Reason (optional)</Label>
        <Textarea data-testid="order-reject-reason-input" value={rejectReason} onChange={(e) => setRejectReason(e.target.value)} placeholder="Why is this order being rejected?" rows={3} />
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>Cancel</Button>
        <Button data-testid="order-reject-submit" variant="destructive" disabled={busy} onClick={onSubmit}>Reject Order</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
